module.exports = __webpack_public_path__ + "static/media/bg.52e17622.png";